module.exports = __webpack_public_path__ + "img/lines-orange-6.280ea024.svg";